<template>
  <v-row id="header" no-gutters align="center">
    <v-col class="header-left">
      <router-link :to="{ name: 'home' }" class="logo-link">
        <img src="@/assets/logoFta.png" alt="FTA" class="logo" />
      </router-link>
      <span v-if="isPreprod" class="preprod-badge">PREPROD</span>
      <nav class="nav-links" aria-label="Navigation principale">
        <router-link :to="{ path: '/projet_bloc_fore' }" class="nav-link">Projets BF</router-link>
        <router-link :to="{ path: '/report' }" class="nav-link">Statistiques</router-link>
        <router-link :to="{ path: '/visites' }" class="nav-link">Visites</router-link>
        <router-link :to="{ path: '/retards_report' }" class="nav-link">Retards</router-link>
      </nav>
    </v-col>

    <v-col cols="auto" class="header-right">
      <nav class="nav-links nav-links--external" aria-label="Liens externes">
        <a target="_blank" href="https://commande.f-t-a.com" class="nav-link nav-link--external" title="Commandes">
          <v-icon size="14">mdi-cart-outline</v-icon><span class="link-label">Commandes</span>
        </a>
        <a target="_blank" href="https://www.planningpme.fr/mon-compte/sign" class="nav-link nav-link--external" title="Planning">
          <v-icon size="14">mdi-calendar-month-outline</v-icon><span class="link-label">Planning</span>
        </a>
        <a v-if="canAccessAchat" target="_blank" href="http://achat.f-t-a.com/" class="nav-link nav-link--external" title="Logiciel Achat">
          <v-icon size="14">mdi-package-variant-closed</v-icon><span class="link-label">Achat</span>
        </a>
      </nav>
      <div class="header-divider"></div>
      <div class="user-info">
        <div class="user-avatar">
          <img src="@/assets/avatar.png" alt="avatar" />
        </div>
        <span class="user-name">
          {{ $store.state.user.nom ? $store.state.user.nom.toUpperCase() : "" }}
        </span>
      </div>
      <button class="logout-btn" @click="logout" title="Se déconnecter">
        <img src="@/assets/logoExit.png" alt="Déconnexion" />
      </button>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "AppHeader",
  computed: {
    effectiveRole() {
      return this.$store.state.AsUser.id_utilisateur
        ? this.$store.state.AsUser.id_role
        : this.$store.state.user.id_role;
    },
    canAccessAchat() {
      return this.effectiveRole === 1 || this.effectiveRole === 3;
    },
    isPreprod() {
      return process.env.VUE_APP_ENV === 'preprod';
    },
  },
  methods: {
    logout() {
      localStorage.removeItem("user-token");
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

#header {
  padding: 0 24px;
  height: 60px;
  background: #fff;
  border-bottom: 2px solid $background-color-blue;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 10;
  flex-wrap: nowrap !important;
  overflow: hidden;
}

.preprod-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 9px;
  background: #ff6f00;
  color: #fff;
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  border-radius: 4px;
  text-transform: uppercase;
  flex-shrink: 0;
}

// ── Left side ───────────────────────────────────────────────────────
.header-left {
  display: flex;
  align-items: center;
  gap: 32px;
  min-width: 0;
  overflow: hidden;
}

.logo-link {
  display: flex;
  align-items: center;
}

.logo {
  height: 36px;
  width: auto;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.nav-link {
  position: relative;
  padding: 6px 12px;
  font-size: 0.875rem;
  font-weight: 600;
  color: $background-color-blue;
  text-decoration: none;
  border-radius: 6px;
  transition: background 0.15s;

  &::after {
    content: '';
    position: absolute;
    bottom: 2px;
    left: 12px;
    right: 12px;
    height: 2px;
    background: $background-color-btn;
    border-radius: 1px;
    transform: scaleX(0);
    transition: transform 0.2s ease;
  }

  &:hover {
    background: lighten(#0B87BA, 52%);

    &::after {
      transform: scaleX(1);
    }
  }
}

// ── Right side ──────────────────────────────────────────────────────
.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.nav-link--external {
  color: #888;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:hover {
    background: #f5f5f5;
    color: #555;

    &::after { display: none; }
  }
}

.header-divider {
  width: 1px;
  height: 24px;
  background: #e0e0e0;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 12px 4px 4px;
  border-radius: 24px;
  background: lighten(#0B87BA, 52%);
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  background: $background-color-blue;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.user-name {
  font-weight: 700;
  font-size: 0.9rem;
  color: $background-color-blue;
  white-space: nowrap;
}

.logout-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  transition: background 0.15s;

  img {
    height: 20px;
    width: auto;
  }

  &:hover {
    background: #fce4e4;
  }
}

// ── Responsive ──────────────────────────────────────────────────────
@media screen and (max-width: 1366px) {
  .logo { height: 30px; }
  .user-name { font-size: 0.82rem; }
}

@media screen and (max-width: 1024px) {
  .nav-link {
    font-size: 0.8rem;
    padding: 6px 8px;
  }
}

@media screen and (max-width: 1100px) {
  #header {
    padding: 0 10px;
    height: 52px;
  }

  .header-left {
    gap: 10px;
  }

  .logo { height: 26px; }

  .nav-link {
    font-size: 0.72rem;
    padding: 4px 6px;
  }

  // External links: icon only
  .link-label { display: none; }
  .header-divider { display: none; }

  // Show only avatar, hide name
  .user-name { display: none; }
  .user-info {
    padding: 4px;
    border-radius: 50%;
    background: transparent;
  }
}
</style>
